import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import NJADVRIForm from './components/NJADVRIForm';
import ResourcesPage from './components/ResourcesPage';
import ScrollToTop from './components/ScrollToTop';
import GDPRBanner from './components/GDPRBanner';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/evaluare" element={<NJADVRIForm />} />
            <Route path="/resurse" element={<ResourcesPage />} />
          </Routes>
          <GDPRBanner />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
